import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
    selector: '[noScrollNumber]',
    standalone: false
})
export class NoScrollNumberDirective {

  constructor(private elementRef: ElementRef) { }

  @HostListener('wheel', ['$event'])
  onWheel(event: WheelEvent) {
    // Prevent wheel events from changing the input value when focused
    if (this.elementRef.nativeElement === document.activeElement) {
      event.preventDefault();
    }
  }

  @HostListener('focus', ['$event'])
  onFocus(event: FocusEvent) {
    // Blur on wheel to prevent accidental changes
    const element = this.elementRef.nativeElement;

    const wheelHandler = (e: WheelEvent) => {
      e.preventDefault();
    };

    element.addEventListener('wheel', wheelHandler, { passive: false });

    // Clean up the event listener when focus is lost
    element.addEventListener('blur', () => {
      element.removeEventListener('wheel', wheelHandler);
    }, { once: true });
  }
} 